const therapyClass = [
          { id: 'Persona adulta', name: 'Persona adulta' },
          { id: 'Persona menor de edad', name: 'Persona menor de edad' },
          { id: 'Terapia vincular', name: 'Terapia vincular' },
      ];

export default therapyClass;
